import { lazy, Suspense } from 'react';
import Spin from 'components/Spin';
import type { IBrandConfig } from './types';

const MissGroupSafeTermsOfService = lazy(
  () => import('pages/terms-of-service/miss-group-safe'),
);

const DSAFE_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: { kind: 'cms', path: 'policy/dshop-policy.md' },
  termsOfService: {
    kind: 'component',
    render: () => (
      <Suspense fallback={<Spin />}>
        <MissGroupSafeTermsOfService />
      </Suspense>
    ),
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  vaultProject: 'dsafe',
  adaChat: false,
  accountDetails: true,
  personalInformation: false,
  secureUpload: false,
  billingDetails: false,
  offersAndUpgrades: false,
  security: false,
  missingPII: false,
  finishSetup: false,
  defaultBillingCategoryKey: 'privacy_breach',
  copyRightEntity: 'Domainkeskus Safe',
  hasCustomerServiceSupport: false,
  ssoRedirectURL: null,
  carouselBanners: false,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability: null,
  },
  supportPage: {
    pageTitle: {
      active: false,
    },
    faq: {
      active: true,
    },
    pages: [
      {
        title: 'Support page',
        href: 'https://help.domainkeskus.com',
        icon: 'support-faq',
        customerSupport: false,
      },
    ],
    call: {},
    mail: {
      active: false,
    },
    email: {
      active: true,
      address: 'info@domainkeskus.com',
      customerSupport: true,
    },
  },
};

export default DSAFE_BRAND_CONFIG;
